<table style="table-layout: fixed; width: 100%;" class="table table-xs tableFixHead" id="nr-report" *ngIf="reportService.reportData.length > 0">
    <thead>
        <tr>
            <th>ID</th>
            <th>{{ level_info?.second_level_name?level_info?.second_level_name:'DSM' }} Name</th>
            <th>{{ level_info?.third_level_name?level_info?.third_level_name:'ASM' }} Name</th>
            <th>District</th>
            <th>City</th>
            <th [hidden]="_wssp_ids_based">{{ level_info?.fourth_level_name?level_info?.fourth_level_name:'Distribution' }}</th>
            <th>Vehicle No</th>
            <th>Vehicle Type</th>
            <th>No. Of NR Vehicle</th>
            <th>Last Reporting Date/Time</th>
            <th>Last Location</th>
            <th>Aging Days</th>
        </tr>
    </thead>
    <tbody>
        <tr class="table-border-double" *ngFor="let nr of reportService.reportData; let i=index" [ngStyle]="{'background-color': nr.row_color, 'color':nr.font_color}">
            <td>{{ nr.level1 }}</td>
            <td>{{ nr.level2 }}</td>
            <td>{{ nr.level3 }}</td>
            <td>{{ nr.state }}&nbsp;</td>
            <td>{{ nr.city }}&nbsp;</td>
            <td [hidden]="_wssp_ids_based">{{ nr.level4 }}</td>
            <td>{{ nr.plate_no }}</td>
            <td>{{ nr.vehicle_model }}</td>
            <td>{{  nr.no_nr_vehicles }}</td>
            <td *ngIf="nr.receiving_date_time">{{ nr.receiving_date_time | date: 'dd/MM/yyyy hh:mm:ss a' }}</td>
            <td *ngIf="!nr.receiving_date_time"></td>
            <td>{{ nr.last_location }}</td>
            <td>{{ nr.aging_days }}</td>
        </tr>
    </tbody>
</table>
